// @core/api/endpoints/workflow/revert_to_version.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PipelineVersionResponse,
  RevertToVersionRequest,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Revert to version
 * Copies the nodes and connections from the specified version into a new draft version. The old draft is discarded.
 */
export async function RevertToVersion(
  version_id: string,
  data: RevertToVersionRequest,
  options?: RequestOptions
): Promise<PipelineVersionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/versions/:version_id/revert`;
  requestPath = requestPath.replace(':version_id', encodeURIComponent(version_id));
  const requestOptions = options;
  return client.post<PipelineVersionResponse>(requestPath, data, requestOptions);
}
